import { BackendId } from "@libs/appliance_common";
export const permissions = [
    // system_management
    {
        id: 1,
        action: "read",
        scope: "logs",
        resource: "system_management",
        description: "Allows downloading system log files."
    },
    {
        id: 2,
        action: "read",
        scope: "status",
        resource: "system_management",
        description: 'Allows viewing "Status" and "Utilization" pages.'
    },
    // qseed
    {
        id: 3,
        action: "read",
        scope: "qseed",
        resource: "qseed",
        description: 'Allows retrieval of qseed service and HSM information (view "Qseed" page).'
    },
    {
        id: 4,
        action: "write",
        scope: "qseed",
        resource: "qseed",
        description: 'Permits updating seed parameters for a given token in an HSM (make edits to "Qseed" page).'
    },
    // outbound_entropy_stream_management
    {
        id: 5,
        action: "read",
        scope: "stream_destinations",
        resource: "outbound_entropy_stream_management",
        description: 'Read list of outbound entropy stream destinations (view "Outbound Stream" page).'
    },
    {
        id: 6,
        action: "write",
        scope: "stream_destinations",
        resource: "outbound_entropy_stream_management",
        description: 'Allows removing a specific entropy stream destination (make edits to "Outbound Stream" page).'
    },
    // user_management
    {
        id: 7,
        action: "read",
        scope: "permissions",
        resource: "user_management",
        description: "Read all permissions."
    },
    {
        id: 8,
        action: "write",
        scope: "roles",
        resource: "user_management",
        description: "Create a new role or update/delete an existing role."
    },
    {
        id: 9,
        action: "read",
        scope: "roles",
        resource: "user_management",
        description: "Read all roles and associated permissions."
    },
    {
        id: 10,
        action: "write",
        scope: "users",
        resource: "user_management",
        description: "Create a new user or update/delete an existing user."
    },
    {
        id: 11,
        action: "read",
        scope: "users",
        resource: "user_management",
        description: "Read all users and associated roles/permissions."
    },
    {
        id: 12,
        action: "write",
        scope: "auth_config",
        resource: "user_management",
        description: "Change auth configuration settings"
    },
    {
        id: 13,
        action: "read",
        scope: "auth_config",
        resource: "user_management",
        description: "Read auth configuration settings."
    },
    // api_key_management
    {
        id: 14,
        action: "read",
        scope: "api_keys",
        resource: "api_keys",
        description: "Allows viewing API keys."
    },
    {
        id: 15,
        action: "write",
        scope: "api_keys",
        resource: "api_keys",
        description: "Allows creating and deleting API keys."
    },
    // ipsec_tunnels
    {
        id: 16,
        action: "read",
        scope: "ipsec",
        resource: "ipsec_tunnels",
        description: 'View the servers which this server has been configured to tunnel between (view "IPsec Tunnels" page).'
    },
    {
        id: 17,
        action: "write",
        scope: "ipsec",
        resource: "ipsec_tunnels",
        description: 'Allows adding, changing, or removing connection configurations (make edits to "IPsec Tunnels" page).'
    },
    // blast_endpoints
    {
        id: 18,
        action: "read",
        scope: "blast_endpoints",
        resource: "blast_endpoints",
        description: 'View BLAST endpoints (view "BLAST Endpoints" page).'
    },
    {
        id: 19,
        action: "write",
        scope: "blast_endpoints",
        resource: "blast_endpoints",
        description: 'Allows adding, updating, or removing BLAST endpoints (make edits to "BLAST Endpoints" page).'
    },
    // cluster_management
    {
        id: 20,
        action: "read",
        scope: "cluster",
        resource: "cluster_management",
        description: "View cluster nodes and status."
    },
    {
        id: 21,
        action: "write",
        scope: "cluster",
        resource: "cluster_management",
        description: "Add or remove nodes from the cluster."
    }
];
export const roles = [
    {
        id: 1,
        name: "Super Admin",
        description: "Full access to all system management. Can read all data and modify all settings.",
        permissions: permissions,
        is_superadmin: true
    },
    {
        id: 2,
        name: "Monitor",
        description: "Read-only access to all system monitoring endpoints. Able to view all UI pages but not change any settings.",
        permissions: permissions.filter((p)=>p.action === "read"),
        is_superadmin: false
    },
    {
        id: 3,
        name: "Operator",
        description: "Read and write access to all system monitoring endpoints. Able to view all UI pages as well as modify settings such as outbound entropy stream destinations and Qseed parameters.",
        permissions: permissions.filter((p)=>p.action === "read" || p.resource === "outbound_entropy_stream_management" && p.action === "write" || p.resource === "qseed" && p.action === "write"),
        is_superadmin: false
    },
    {
        id: 4,
        name: "User Manager",
        description: "Can create, update, and delete users and roles, and manage their permissions. Also able to view all UI pages but not change any settings.",
        permissions: permissions.filter((p)=>p.action === "read" || p.resource === "user_management" && p.action === "write"),
        is_superadmin: false
    }
];
export const users = [
    {
        id: "1",
        username: "superadmin",
        roles: [
            roles[0]
        ],
        permissions: roles[0].permissions,
        is_superadmin: true,
        backend: BackendId.Local
    },
    {
        id: "2",
        username: "readonly",
        roles: [
            roles[1]
        ],
        permissions: roles[1].permissions,
        is_superadmin: false,
        backend: BackendId.Local
    },
    {
        id: "3",
        username: "forbidden",
        roles: [],
        permissions: [],
        is_superadmin: false,
        backend: BackendId.Local
    },
    {
        id: "4",
        username: "john.doe",
        roles: [
            roles[2]
        ],
        permissions: roles[2].permissions,
        is_superadmin: false,
        backend: BackendId.LDAP
    },
    {
        id: "5",
        username: "jane.smith",
        roles: [
            roles[1]
        ],
        permissions: roles[1].permissions,
        is_superadmin: false,
        backend: BackendId.LDAP
    }
];
/** Encode a string as unpadded base64url (the encoding JWTs use). */ function base64url(input) {
    return btoa(input).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function generateMockAccessToken(user, roles, permissions) {
    const header = base64url(JSON.stringify({
        alg: "HS512",
        typ: "JWT"
    }));
    const payload = {
        iat: Math.floor(Date.now() / 1000),
        exp: Math.floor(Date.now() / 1000) + 120,
        user,
        roles,
        permissions,
        must_change_password: false
    };
    const encodedPayload = base64url(JSON.stringify(payload, (_key, value)=>typeof value === "bigint" ? Number(value) : value));
    // Signature is not validated by the frontend; use a placeholder.
    const signature = base64url("mockSignature");
    return `${header}.${encodedPayload}.${signature}`;
}
export const mockSuperAdminAccessToken = generateMockAccessToken({
    id: users[0].id,
    username: users[0].username,
    is_superadmin: users[0].is_superadmin,
    backend: users[0].backend
}, users[0].roles, users[0].permissions);
export const mockReadOnlyAccessToken = generateMockAccessToken({
    id: users[1].id,
    username: users[1].username,
    is_superadmin: users[1].is_superadmin,
    backend: users[1].backend
}, users[1].roles, users[1].permissions);
export const mockForbiddenAccessToken = generateMockAccessToken({
    id: users[2].id,
    username: users[2].username,
    is_superadmin: users[2].is_superadmin,
    backend: users[2].backend
}, users[2].roles, users[2].permissions);
// External group to role mappings (LDAP DN -> Role ID)
export const externalScopeMappings = [
    {
        id: 1,
        external_scope_id: "cn=Admins,ou=Groups,dc=example,dc=com",
        role_id: 1,
        created_at: new Date().toISOString()
    },
    {
        id: 2,
        external_scope_id: "cn=Developers,ou=Groups,dc=example,dc=com",
        role_id: 3,
        created_at: new Date().toISOString()
    },
    {
        id: 3,
        external_scope_id: "cn=ReadOnly,ou=Groups,dc=example,dc=com",
        role_id: 2,
        created_at: new Date().toISOString()
    }
];
// LDAP Configuration
export const ldapConfig = {
    directory_name: "Mock LDAP Directory",
    server_url: "ldaps://ldap.example.com:636",
    bind_dn: "cn=admin,dc=example,dc=com",
    user_table: "ou=Users,dc=example,dc=com",
    user_id_attribute: "uid",
    user_role_attribute: "memberOf",
    created_at: new Date().toISOString()
};
// Available LDAP groups that can be mapped to roles
export const availableLdapGroups = [
    "cn=Admins,ou=Groups,dc=example,dc=com",
    "cn=Developers,ou=Groups,dc=example,dc=com",
    "cn=ReadOnly,ou=Groups,dc=example,dc=com",
    "cn=Engineering,ou=Groups,dc=example,dc=com",
    "cn=Support,ou=Groups,dc=example,dc=com",
    "cn=Security,ou=Groups,dc=example,dc=com"
];
// Available OIDC roles (Keycloak realm roles) that can be mapped to roles
export const availableOidcRoles = [
    "admin",
    "user",
    "offline_access",
    "uma_authorization",
    "default-roles-quickstart"
];
